module.exports = __webpack_public_path__ + "media/brand/logo-qr-cc5def88.svg";